import clsx from 'clsx'

export const variants = {
  primary: clsx('tw-bg-primary-500'),
  alert: clsx('tw-bg-alert-500'),
}
